export enum FTE_UTILS {
  CONTENT = 'content',
  CALENDAR = 'calendar',
  CONTACT = 'contact',
  DASHBOARD = 'dashboard',
  LIBRARY = 'library',
  ATHLETE_PROFILE = 'Athlete Profile',
}
